<template>
    <div class="body">
        <BarScan ref="qrcode" @ok="getResult" @stop="getStop" @err="geterror" v-if="isScanning"></BarScan>
        <div class="content" v-if="!isScanning">
            <div class="body-t">
                <div class="img1"></div>
                学生综合评价系统自助终端
                <div class="tip" @click="isScanning=true">
                    <span>录入积分卡数量: 3张</span>
                    <span>新增积分: 15分</span>
                </div>
            </div>
            <div class="box">
                <div class="box-1" @click="readerJump()">
                    <el-image style="width: 400px; height: 340px"
                              :src="require('../../assets/pointsImgs/entering.png')">
                    </el-image>
                </div>
                <div class="box-2">
                    <div class="text">请将积分卡对准下方的摄像头</div>
                    <div class="icon">
                        <i class="el-icon-bottom"></i>
                    </div>
                </div>
            </div>
            <div class="body-b">
                <div class="img2"></div>
                易学云智能
                <div class="qrCode"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import BarScan from '@/components/qrcode.vue'

    export default {
        name: "entering",
        components: {BarScan },
        data() {
            return {
                isScanning: false
            }
        },
        created() {

        },
        methods: {
            getResult(result) {
                console.log(result)
                this.$message({
                    type: 'success',
                    message: result
                });
            },
            geterror(e) {
                // console.log(e)
                this.$message({
                    type: 'warning',
                    message: e
                });
            },
            getStop() {
                this.isScanning = false
            },
            readerJump(){
                // this.$router.push('/qrcodeReader')
            },

        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        height: 100%;
        position: relative;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
    }
    .content{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .body-t {
        width: 100%;
        height: 87px;
        line-height: 87px;
        color: white;
        background: url("../../assets/pointsImgs/pointsHomebg1.png") no-repeat center 0;
        font-size: 48px;
        display: flex;
        align-items: center;
    }

    .img1 {
        width: 70px;
        height: 70px;
        background: url("../../assets/pointsImgs/pointsHomebg3.png") no-repeat center 0;
        margin: 0 30px;
    }

    .tip {
        height: 72px;
        line-height: 72px;
        border-radius: 36px;
        background: #FF9800;
        font-size: 28px;
        padding: 0 40px;
        position: absolute;
        top: 8px;
        right: 30px;
    }

    .tip > span {
        display: inline-block;
        padding: 0 20px;
    }

    .body-b {
        position: relative;
        /*bottom: 0;*/
        /*left: 0;*/
        width: 100%;
        height: 121px;
        background: url("../../assets/pointsImgs/pointsHomebg2.png") no-repeat center 0;
        font-size: 36px;
        display: flex;
        align-items: center;
        color: white;
    }

    .img2 {
        width: 70px;
        height: 70px;
        background: url("../../assets/pointsImgs/pointsHomebg4.png") no-repeat center 0;
        margin: 0 30px;
    }

    .qrCode {
        width: 100px;
        height: 100px;
        background: url("../../assets/pointsImgs/qrCode.png") no-repeat center 0;
        position: absolute;
        top: 10px;
        right: 25px;
    }

    .box {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .box-1 {
        text-align: center;
    }

    .box-2 {
        flex: 1;
        border-radius: 20px 20px 2px 2px;
        background: #C6C6C6;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .text {
        font-size: 72px;
        text-align: center;
        padding: 40px 0;
    }

    .icon {
        width: 140px;
        height: 140px;
        border-radius: 50%;
        background: #16C4AF;
        color: #C3F4EA;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 108px;
        margin: 20px auto;
    }
</style>
